import Vue from 'vue';
import { keyBy } from 'lodash';
import types from './mutation-types';

const mutations = {
  [types.SET_IS_CLASS_STUDENT](state, isClassStudent) {
    Vue.set(state, 'isClassStudent', isClassStudent);
  },

  [types.SET_SELECTED](state, classId) {
    Vue.set(state, 'selectedClassId', classId);
  },

  [types.SET_CLASSES](state, classList) {
    Vue.set(state, 'managingClasses', keyBy(classList, 'id'));
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/classes/store/mutations.js